import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { ArrowRight, Loader2, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const INTENTS = [["sell", "I'm selling"], ["buy", "I'm buying"], ["both", "Both"]];

export const WaitlistForm = ({ testPrefix }) => {
  const [email, setEmail] = useState("");
  const [intent, setIntent] = useState("both");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    if (!/^\S+@\S+\.\S+$/.test(email)) return toast.error("Please enter a valid email.");
    setState("loading");
    try {
      const { data } = await axios.post(`${API}/waitlist`, { email, intent });
      setState("done");
      toast.success(data?.already ? "You're already on the list." : "You're in. We'll be in touch.");
    } catch {
      setState("idle");
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <form onSubmit={submit} data-testid={`${testPrefix}-waitlist-form`}>
      <div className="mb-3 flex flex-wrap gap-2">
        {INTENTS.map(([k, label]) => (
          <button type="button" key={k} onClick={() => setIntent(k)} data-testid={`${testPrefix}-intent-${k}`}
            className={`rounded-full border px-3 py-1 text-xs font-medium transition-colors ${intent === k ? "border-[#FF3838] bg-[#FF3838]/15 text-white" : "border-white/15 text-zinc-400 hover:text-white"}`}>
            {label}
          </button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-2 rounded-2xl sm:rounded-full border border-white/15 bg-[#12141C]/80 p-1.5 backdrop-blur-xl focus-within:border-[#FF3838]/60 transition-colors">
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com"
          disabled={state === "done"} data-testid={`${testPrefix}-email-input`}
          className="flex-1 bg-transparent px-4 py-3 text-sm text-white placeholder:text-zinc-500 outline-none" />
        <button type="submit" disabled={state !== "idle"} data-testid={`${testPrefix}-submit-btn`}
          className="group inline-flex items-center justify-center gap-2 rounded-full bg-[#FF3838] px-6 py-3 text-sm font-bold text-[#0A0B0E] hover:bg-[#ff5656] active:scale-[0.97] transition-[background-color,transform] disabled:opacity-80">
          {state === "loading" && <Loader2 className="h-4 w-4 animate-spin" />}
          {state === "done" && <Check className="h-4 w-4" />}
          {state === "done" ? "On the list" : "Get early access"}
          {state === "idle" && <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />}
        </button>
      </div>
    </form>
  );
};
